// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-js-cron {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
}
.react-js-cron > div,
.react-js-cron-field {
  display: flex;
  align-items: center;
}
.react-js-cron-field {
  margin-bottom: 10px;
}
.react-js-cron-field > span {
  margin-left: 5px;
}
div.react-js-cron-select {
  margin-left: 5px;
}
.react-js-cron-select.react-js-cron-select-no-prefix {
  margin-left: 0;
}
div.react-js-cron-error .react-js-cron-select .ant-select-selector {
  border-color: #ff4d4f;
  background: #fff6f6;
}
div.react-js-cron-custom-select {
  min-width: 70px;
  z-index: 1;
}
div.react-js-cron-error div.react-js-cron-custom-select {
  background: #fff6f6;
}
div.react-js-cron-select.react-js-cron-custom-select.ant-select
  div.ant-select-selector {
  padding-left: 11px;
  padding-right: 30px;
}
.react-js-cron-read-only
  div.react-js-cron-select.react-js-cron-custom-select.ant-select
  div.ant-select-selector {
  padding-right: 11px;
}
div.react-js-cron-custom-select .ant-select-selection-search {
  width: 0 !important;
  margin: 0 !important;
}
div.react-js-cron-custom-select .ant-select-selection-placeholder {
  position: static;
  top: 50%;
  right: auto;
  left: auto;
  transform: none;
  transition: none;
  opacity: 1;
  color: inherit;
}
.react-js-cron-week-days-placeholder
  .react-js-cron-custom-select
  .ant-select-selection-placeholder,
.react-js-cron-month-days-placeholder
  .react-js-cron-custom-select
  .ant-select-selection-placeholder {
  opacity: 0.4;
}
.react-js-cron-custom-select-dropdown {
  min-width: 0 !important;
  width: 170px !important;
}
.react-js-cron-custom-select-dropdown .rc-virtual-list {
  max-height: none !important;
}
.react-js-cron-custom-select-dropdown-grid .rc-virtual-list-holder-inner {
  display: grid !important;
  grid-template-columns: repeat(4, 1fr);
}
.react-js-cron-custom-select-dropdown-grid
  .rc-virtual-list-holder-inner
  .ant-select-item-option-content {
  text-align: center;
}
.react-js-cron-custom-select-dropdown-hours-twelve-hour-clock {
  width: 260px !important;
}
.react-js-cron-custom-select-dropdown-minutes-large {
  width: 300px !important;
}
.react-js-cron-custom-select-dropdown-minutes-large
  .rc-virtual-list-holder-inner {
  grid-template-columns: repeat(7, 1fr);
}
.react-js-cron-custom-select-dropdown-minutes-medium {
  width: 215px !important;
}
.react-js-cron-custom-select-dropdown-minutes-medium
  .rc-virtual-list-holder-inner {
  grid-template-columns: repeat(5, 1fr);
}
.react-js-cron-period > span:first-child {
  margin-left: 0 !important;
}
.react-js-cron-period
  .react-js-cron-select.ant-select-single.ant-select-open
  .ant-select-selection-item {
  opacity: 1;
}
.react-js-cron-select-dropdown-period {
  min-width: 0 !important;
  width: auto !important;
}
.react-js-cron-clear-button {
  margin-left: 10px;
  margin-bottom: 10px;
}
.react-js-cron-disabled .react-js-cron-select.ant-select-disabled {
  background: #f5f5f5;
}
div.react-js-cron-select.react-js-cron-custom-select.ant-select
  div.ant-select-selector
  > .ant-select-selection-overflow {
  align-items: center;
  flex: initial;
}
`, "",{"version":3,"sources":["webpack://./node_modules/react-js-cron/dist/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;AACA;;EAEE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;;EAGE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,cAAc;AAChB;AACA;;;;;;EAME,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,wBAAwB;EACxB,qCAAqC;AACvC;AACA;;;EAGE,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,qCAAqC;AACvC;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,qCAAqC;AACvC;AACA;EACE,yBAAyB;AAC3B;AACA;;;EAGE,UAAU;AACZ;AACA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;;EAGE,mBAAmB;EACnB,aAAa;AACf","sourcesContent":[".react-js-cron {\n  display: flex;\n  align-items: flex-start;\n  flex-wrap: wrap;\n}\n.react-js-cron > div,\n.react-js-cron-field {\n  display: flex;\n  align-items: center;\n}\n.react-js-cron-field {\n  margin-bottom: 10px;\n}\n.react-js-cron-field > span {\n  margin-left: 5px;\n}\ndiv.react-js-cron-select {\n  margin-left: 5px;\n}\n.react-js-cron-select.react-js-cron-select-no-prefix {\n  margin-left: 0;\n}\ndiv.react-js-cron-error .react-js-cron-select .ant-select-selector {\n  border-color: #ff4d4f;\n  background: #fff6f6;\n}\ndiv.react-js-cron-custom-select {\n  min-width: 70px;\n  z-index: 1;\n}\ndiv.react-js-cron-error div.react-js-cron-custom-select {\n  background: #fff6f6;\n}\ndiv.react-js-cron-select.react-js-cron-custom-select.ant-select\n  div.ant-select-selector {\n  padding-left: 11px;\n  padding-right: 30px;\n}\n.react-js-cron-read-only\n  div.react-js-cron-select.react-js-cron-custom-select.ant-select\n  div.ant-select-selector {\n  padding-right: 11px;\n}\ndiv.react-js-cron-custom-select .ant-select-selection-search {\n  width: 0 !important;\n  margin: 0 !important;\n}\ndiv.react-js-cron-custom-select .ant-select-selection-placeholder {\n  position: static;\n  top: 50%;\n  right: auto;\n  left: auto;\n  transform: none;\n  transition: none;\n  opacity: 1;\n  color: inherit;\n}\n.react-js-cron-week-days-placeholder\n  .react-js-cron-custom-select\n  .ant-select-selection-placeholder,\n.react-js-cron-month-days-placeholder\n  .react-js-cron-custom-select\n  .ant-select-selection-placeholder {\n  opacity: 0.4;\n}\n.react-js-cron-custom-select-dropdown {\n  min-width: 0 !important;\n  width: 170px !important;\n}\n.react-js-cron-custom-select-dropdown .rc-virtual-list {\n  max-height: none !important;\n}\n.react-js-cron-custom-select-dropdown-grid .rc-virtual-list-holder-inner {\n  display: grid !important;\n  grid-template-columns: repeat(4, 1fr);\n}\n.react-js-cron-custom-select-dropdown-grid\n  .rc-virtual-list-holder-inner\n  .ant-select-item-option-content {\n  text-align: center;\n}\n.react-js-cron-custom-select-dropdown-hours-twelve-hour-clock {\n  width: 260px !important;\n}\n.react-js-cron-custom-select-dropdown-minutes-large {\n  width: 300px !important;\n}\n.react-js-cron-custom-select-dropdown-minutes-large\n  .rc-virtual-list-holder-inner {\n  grid-template-columns: repeat(7, 1fr);\n}\n.react-js-cron-custom-select-dropdown-minutes-medium {\n  width: 215px !important;\n}\n.react-js-cron-custom-select-dropdown-minutes-medium\n  .rc-virtual-list-holder-inner {\n  grid-template-columns: repeat(5, 1fr);\n}\n.react-js-cron-period > span:first-child {\n  margin-left: 0 !important;\n}\n.react-js-cron-period\n  .react-js-cron-select.ant-select-single.ant-select-open\n  .ant-select-selection-item {\n  opacity: 1;\n}\n.react-js-cron-select-dropdown-period {\n  min-width: 0 !important;\n  width: auto !important;\n}\n.react-js-cron-clear-button {\n  margin-left: 10px;\n  margin-bottom: 10px;\n}\n.react-js-cron-disabled .react-js-cron-select.ant-select-disabled {\n  background: #f5f5f5;\n}\ndiv.react-js-cron-select.react-js-cron-custom-select.ant-select\n  div.ant-select-selector\n  > .ant-select-selection-overflow {\n  align-items: center;\n  flex: initial;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
